export const RECAPTCHA_SITE_KEY = '6LeB0aYdAAAAAB2fhgFiZZYoZEjp6SfZf96HLa4Y';
